/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AppAddonsRouteImport } from './routes/_app/addons'
import { Route as AppCustomerPortalEditorRouteImport } from './routes/_app/customer-portal-editor'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppLeadsRouteImport } from './routes/_app/leads'
import { Route as AppProfileRouteImport } from './routes/_app/profile'
import { Route as AppTyreConfigRouteImport } from './routes/_app/tyre-config'
import { Route as AppTyreSpecsRouteImport } from './routes/_app/tyre-specs'
import { Route as AppUnauthorizedRouteImport } from './routes/_app/unauthorized'
import { Route as AppUnavailableRouteImport } from './routes/_app/unavailable'
import { Route as AppVehicleServiceOffersRouteImport } from './routes/_app/vehicle-service-offers'
import { Route as AppVehicleSpecsRouteImport } from './routes/_app/vehicle-specs'
import { Route as ResetPasswordIndexRouteImport } from './routes/reset-password/index'
import { Route as ResetPasswordTokenRouteImport } from './routes/reset-password/$token'
import { Route as AppCustomersTyresRouteImport } from './routes/_app/customers/tyres'
import { Route as AppEmailTemplatesBuilderRouteImport } from './routes/_app/email-templates/builder'
import { Route as AppOrdersTyresRouteImport } from './routes/_app/orders/tyres'
import { Route as AppOverviewSectionIdRouteImport } from './routes/_app/overview/$sectionId'
import { Route as AppPdfTemplatesBuilderRouteImport } from './routes/_app/pdf-templates/builder'
import { Route as AppServiceAgreementAddonsRouteImport } from './routes/_app/service-agreement/addons'
import { Route as AppServiceAgreementComplianceRouteImport } from './routes/_app/service-agreement/compliance'
import { Route as AppServiceAgreementCustomersRouteImport } from './routes/_app/service-agreement/customers'
import { Route as AppServiceAgreementSettingsRouteImport } from './routes/_app/service-agreement/settings'
import { Route as AppServiceAgreementOrdersIndexRouteImport } from './routes/_app/service-agreement/orders/index'
import { Route as AppServiceAgreementOrdersOrderIdRouteImport } from './routes/_app/service-agreement/orders/$orderId'
import { Route as AppServiceAgreementOrdersCalculateRouteImport } from './routes/_app/service-agreement/orders/calculate'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAddonsRoute = AppAddonsRouteImport.update({
  id: '/addons',
  path: '/addons',
  getParentRoute: () => AppRoute,
} as any)
const AppCustomerPortalEditorRoute = AppCustomerPortalEditorRouteImport.update({
  id: '/customer-portal-editor',
  path: '/customer-portal-editor',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppLeadsRoute = AppLeadsRouteImport.update({
  id: '/leads',
  path: '/leads',
  getParentRoute: () => AppRoute,
} as any)
const AppProfileRoute = AppProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppRoute,
} as any)
const AppTyreConfigRoute = AppTyreConfigRouteImport.update({
  id: '/tyre-config',
  path: '/tyre-config',
  getParentRoute: () => AppRoute,
} as any)
const AppTyreSpecsRoute = AppTyreSpecsRouteImport.update({
  id: '/tyre-specs',
  path: '/tyre-specs',
  getParentRoute: () => AppRoute,
} as any)
const AppUnauthorizedRoute = AppUnauthorizedRouteImport.update({
  id: '/unauthorized',
  path: '/unauthorized',
  getParentRoute: () => AppRoute,
} as any)
const AppUnavailableRoute = AppUnavailableRouteImport.update({
  id: '/unavailable',
  path: '/unavailable',
  getParentRoute: () => AppRoute,
} as any)
const AppVehicleServiceOffersRoute = AppVehicleServiceOffersRouteImport.update({
  id: '/vehicle-service-offers',
  path: '/vehicle-service-offers',
  getParentRoute: () => AppRoute,
} as any)
const AppVehicleSpecsRoute = AppVehicleSpecsRouteImport.update({
  id: '/vehicle-specs',
  path: '/vehicle-specs',
  getParentRoute: () => AppRoute,
} as any)
const ResetPasswordIndexRoute = ResetPasswordIndexRouteImport.update({
  id: '/reset-password/',
  path: '/reset-password/',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordTokenRoute = ResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppCustomersTyresRoute = AppCustomersTyresRouteImport.update({
  id: '/customers/tyres',
  path: '/customers/tyres',
  getParentRoute: () => AppRoute,
} as any)
const AppEmailTemplatesBuilderRoute =
  AppEmailTemplatesBuilderRouteImport.update({
    id: '/email-templates/builder',
    path: '/email-templates/builder',
    getParentRoute: () => AppRoute,
  } as any)
const AppOrdersTyresRoute = AppOrdersTyresRouteImport.update({
  id: '/orders/tyres',
  path: '/orders/tyres',
  getParentRoute: () => AppRoute,
} as any)
const AppOverviewSectionIdRoute = AppOverviewSectionIdRouteImport.update({
  id: '/overview/$sectionId',
  path: '/overview/$sectionId',
  getParentRoute: () => AppRoute,
} as any)
const AppPdfTemplatesBuilderRoute = AppPdfTemplatesBuilderRouteImport.update({
  id: '/pdf-templates/builder',
  path: '/pdf-templates/builder',
  getParentRoute: () => AppRoute,
} as any)
const AppServiceAgreementAddonsRoute =
  AppServiceAgreementAddonsRouteImport.update({
    id: '/service-agreement/addons',
    path: '/service-agreement/addons',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementComplianceRoute =
  AppServiceAgreementComplianceRouteImport.update({
    id: '/service-agreement/compliance',
    path: '/service-agreement/compliance',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementCustomersRoute =
  AppServiceAgreementCustomersRouteImport.update({
    id: '/service-agreement/customers',
    path: '/service-agreement/customers',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementSettingsRoute =
  AppServiceAgreementSettingsRouteImport.update({
    id: '/service-agreement/settings',
    path: '/service-agreement/settings',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementOrdersIndexRoute =
  AppServiceAgreementOrdersIndexRouteImport.update({
    id: '/service-agreement/orders/',
    path: '/service-agreement/orders/',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementOrdersOrderIdRoute =
  AppServiceAgreementOrdersOrderIdRouteImport.update({
    id: '/service-agreement/orders/$orderId',
    path: '/service-agreement/orders/$orderId',
    getParentRoute: () => AppRoute,
  } as any)
const AppServiceAgreementOrdersCalculateRoute =
  AppServiceAgreementOrdersCalculateRouteImport.update({
    id: '/service-agreement/orders/calculate',
    path: '/service-agreement/orders/calculate',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/addons': typeof AppAddonsRoute
  '/customer-portal-editor': typeof AppCustomerPortalEditorRoute
  '/dashboard': typeof AppDashboardRoute
  '/leads': typeof AppLeadsRoute
  '/profile': typeof AppProfileRoute
  '/tyre-config': typeof AppTyreConfigRoute
  '/tyre-specs': typeof AppTyreSpecsRoute
  '/unauthorized': typeof AppUnauthorizedRoute
  '/unavailable': typeof AppUnavailableRoute
  '/vehicle-service-offers': typeof AppVehicleServiceOffersRoute
  '/vehicle-specs': typeof AppVehicleSpecsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/customers/tyres': typeof AppCustomersTyresRoute
  '/email-templates/builder': typeof AppEmailTemplatesBuilderRoute
  '/orders/tyres': typeof AppOrdersTyresRoute
  '/overview/$sectionId': typeof AppOverviewSectionIdRoute
  '/pdf-templates/builder': typeof AppPdfTemplatesBuilderRoute
  '/service-agreement/addons': typeof AppServiceAgreementAddonsRoute
  '/service-agreement/compliance': typeof AppServiceAgreementComplianceRoute
  '/service-agreement/customers': typeof AppServiceAgreementCustomersRoute
  '/service-agreement/settings': typeof AppServiceAgreementSettingsRoute
  '/service-agreement/orders/$orderId': typeof AppServiceAgreementOrdersOrderIdRoute
  '/service-agreement/orders/calculate': typeof AppServiceAgreementOrdersCalculateRoute
  '/service-agreement/orders/': typeof AppServiceAgreementOrdersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/addons': typeof AppAddonsRoute
  '/customer-portal-editor': typeof AppCustomerPortalEditorRoute
  '/dashboard': typeof AppDashboardRoute
  '/leads': typeof AppLeadsRoute
  '/profile': typeof AppProfileRoute
  '/tyre-config': typeof AppTyreConfigRoute
  '/tyre-specs': typeof AppTyreSpecsRoute
  '/unauthorized': typeof AppUnauthorizedRoute
  '/unavailable': typeof AppUnavailableRoute
  '/vehicle-service-offers': typeof AppVehicleServiceOffersRoute
  '/vehicle-specs': typeof AppVehicleSpecsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password': typeof ResetPasswordIndexRoute
  '/customers/tyres': typeof AppCustomersTyresRoute
  '/email-templates/builder': typeof AppEmailTemplatesBuilderRoute
  '/orders/tyres': typeof AppOrdersTyresRoute
  '/overview/$sectionId': typeof AppOverviewSectionIdRoute
  '/pdf-templates/builder': typeof AppPdfTemplatesBuilderRoute
  '/service-agreement/addons': typeof AppServiceAgreementAddonsRoute
  '/service-agreement/compliance': typeof AppServiceAgreementComplianceRoute
  '/service-agreement/customers': typeof AppServiceAgreementCustomersRoute
  '/service-agreement/settings': typeof AppServiceAgreementSettingsRoute
  '/service-agreement/orders/$orderId': typeof AppServiceAgreementOrdersOrderIdRoute
  '/service-agreement/orders/calculate': typeof AppServiceAgreementOrdersCalculateRoute
  '/service-agreement/orders': typeof AppServiceAgreementOrdersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/_app/addons': typeof AppAddonsRoute
  '/_app/customer-portal-editor': typeof AppCustomerPortalEditorRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/leads': typeof AppLeadsRoute
  '/_app/profile': typeof AppProfileRoute
  '/_app/tyre-config': typeof AppTyreConfigRoute
  '/_app/tyre-specs': typeof AppTyreSpecsRoute
  '/_app/unauthorized': typeof AppUnauthorizedRoute
  '/_app/unavailable': typeof AppUnavailableRoute
  '/_app/vehicle-service-offers': typeof AppVehicleServiceOffersRoute
  '/_app/vehicle-specs': typeof AppVehicleSpecsRoute
  '/reset-password/$token': typeof ResetPasswordTokenRoute
  '/reset-password/': typeof ResetPasswordIndexRoute
  '/_app/customers/tyres': typeof AppCustomersTyresRoute
  '/_app/email-templates/builder': typeof AppEmailTemplatesBuilderRoute
  '/_app/orders/tyres': typeof AppOrdersTyresRoute
  '/_app/overview/$sectionId': typeof AppOverviewSectionIdRoute
  '/_app/pdf-templates/builder': typeof AppPdfTemplatesBuilderRoute
  '/_app/service-agreement/addons': typeof AppServiceAgreementAddonsRoute
  '/_app/service-agreement/compliance': typeof AppServiceAgreementComplianceRoute
  '/_app/service-agreement/customers': typeof AppServiceAgreementCustomersRoute
  '/_app/service-agreement/settings': typeof AppServiceAgreementSettingsRoute
  '/_app/service-agreement/orders/$orderId': typeof AppServiceAgreementOrdersOrderIdRoute
  '/_app/service-agreement/orders/calculate': typeof AppServiceAgreementOrdersCalculateRoute
  '/_app/service-agreement/orders/': typeof AppServiceAgreementOrdersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/addons'
    | '/customer-portal-editor'
    | '/dashboard'
    | '/leads'
    | '/profile'
    | '/tyre-config'
    | '/tyre-specs'
    | '/unauthorized'
    | '/unavailable'
    | '/vehicle-service-offers'
    | '/vehicle-specs'
    | '/reset-password/$token'
    | '/reset-password/'
    | '/customers/tyres'
    | '/email-templates/builder'
    | '/orders/tyres'
    | '/overview/$sectionId'
    | '/pdf-templates/builder'
    | '/service-agreement/addons'
    | '/service-agreement/compliance'
    | '/service-agreement/customers'
    | '/service-agreement/settings'
    | '/service-agreement/orders/$orderId'
    | '/service-agreement/orders/calculate'
    | '/service-agreement/orders/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/addons'
    | '/customer-portal-editor'
    | '/dashboard'
    | '/leads'
    | '/profile'
    | '/tyre-config'
    | '/tyre-specs'
    | '/unauthorized'
    | '/unavailable'
    | '/vehicle-service-offers'
    | '/vehicle-specs'
    | '/reset-password/$token'
    | '/reset-password'
    | '/customers/tyres'
    | '/email-templates/builder'
    | '/orders/tyres'
    | '/overview/$sectionId'
    | '/pdf-templates/builder'
    | '/service-agreement/addons'
    | '/service-agreement/compliance'
    | '/service-agreement/customers'
    | '/service-agreement/settings'
    | '/service-agreement/orders/$orderId'
    | '/service-agreement/orders/calculate'
    | '/service-agreement/orders'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/_app/addons'
    | '/_app/customer-portal-editor'
    | '/_app/dashboard'
    | '/_app/leads'
    | '/_app/profile'
    | '/_app/tyre-config'
    | '/_app/tyre-specs'
    | '/_app/unauthorized'
    | '/_app/unavailable'
    | '/_app/vehicle-service-offers'
    | '/_app/vehicle-specs'
    | '/reset-password/$token'
    | '/reset-password/'
    | '/_app/customers/tyres'
    | '/_app/email-templates/builder'
    | '/_app/orders/tyres'
    | '/_app/overview/$sectionId'
    | '/_app/pdf-templates/builder'
    | '/_app/service-agreement/addons'
    | '/_app/service-agreement/compliance'
    | '/_app/service-agreement/customers'
    | '/_app/service-agreement/settings'
    | '/_app/service-agreement/orders/$orderId'
    | '/_app/service-agreement/orders/calculate'
    | '/_app/service-agreement/orders/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordTokenRoute: typeof ResetPasswordTokenRoute
  ResetPasswordIndexRoute: typeof ResetPasswordIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/addons': {
      id: '/_app/addons'
      path: '/addons'
      fullPath: '/addons'
      preLoaderRoute: typeof AppAddonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/customer-portal-editor': {
      id: '/_app/customer-portal-editor'
      path: '/customer-portal-editor'
      fullPath: '/customer-portal-editor'
      preLoaderRoute: typeof AppCustomerPortalEditorRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/leads': {
      id: '/_app/leads'
      path: '/leads'
      fullPath: '/leads'
      preLoaderRoute: typeof AppLeadsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/profile': {
      id: '/_app/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AppProfileRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tyre-config': {
      id: '/_app/tyre-config'
      path: '/tyre-config'
      fullPath: '/tyre-config'
      preLoaderRoute: typeof AppTyreConfigRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tyre-specs': {
      id: '/_app/tyre-specs'
      path: '/tyre-specs'
      fullPath: '/tyre-specs'
      preLoaderRoute: typeof AppTyreSpecsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/unauthorized': {
      id: '/_app/unauthorized'
      path: '/unauthorized'
      fullPath: '/unauthorized'
      preLoaderRoute: typeof AppUnauthorizedRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/unavailable': {
      id: '/_app/unavailable'
      path: '/unavailable'
      fullPath: '/unavailable'
      preLoaderRoute: typeof AppUnavailableRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicle-service-offers': {
      id: '/_app/vehicle-service-offers'
      path: '/vehicle-service-offers'
      fullPath: '/vehicle-service-offers'
      preLoaderRoute: typeof AppVehicleServiceOffersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/vehicle-specs': {
      id: '/_app/vehicle-specs'
      path: '/vehicle-specs'
      fullPath: '/vehicle-specs'
      preLoaderRoute: typeof AppVehicleSpecsRouteImport
      parentRoute: typeof AppRoute
    }
    '/reset-password/': {
      id: '/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof ResetPasswordIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password/$token': {
      id: '/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof ResetPasswordTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/customers/tyres': {
      id: '/_app/customers/tyres'
      path: '/customers/tyres'
      fullPath: '/customers/tyres'
      preLoaderRoute: typeof AppCustomersTyresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/email-templates/builder': {
      id: '/_app/email-templates/builder'
      path: '/email-templates/builder'
      fullPath: '/email-templates/builder'
      preLoaderRoute: typeof AppEmailTemplatesBuilderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/orders/tyres': {
      id: '/_app/orders/tyres'
      path: '/orders/tyres'
      fullPath: '/orders/tyres'
      preLoaderRoute: typeof AppOrdersTyresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/overview/$sectionId': {
      id: '/_app/overview/$sectionId'
      path: '/overview/$sectionId'
      fullPath: '/overview/$sectionId'
      preLoaderRoute: typeof AppOverviewSectionIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pdf-templates/builder': {
      id: '/_app/pdf-templates/builder'
      path: '/pdf-templates/builder'
      fullPath: '/pdf-templates/builder'
      preLoaderRoute: typeof AppPdfTemplatesBuilderRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/addons': {
      id: '/_app/service-agreement/addons'
      path: '/service-agreement/addons'
      fullPath: '/service-agreement/addons'
      preLoaderRoute: typeof AppServiceAgreementAddonsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/compliance': {
      id: '/_app/service-agreement/compliance'
      path: '/service-agreement/compliance'
      fullPath: '/service-agreement/compliance'
      preLoaderRoute: typeof AppServiceAgreementComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/customers': {
      id: '/_app/service-agreement/customers'
      path: '/service-agreement/customers'
      fullPath: '/service-agreement/customers'
      preLoaderRoute: typeof AppServiceAgreementCustomersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/settings': {
      id: '/_app/service-agreement/settings'
      path: '/service-agreement/settings'
      fullPath: '/service-agreement/settings'
      preLoaderRoute: typeof AppServiceAgreementSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/orders/': {
      id: '/_app/service-agreement/orders/'
      path: '/service-agreement/orders'
      fullPath: '/service-agreement/orders/'
      preLoaderRoute: typeof AppServiceAgreementOrdersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/orders/$orderId': {
      id: '/_app/service-agreement/orders/$orderId'
      path: '/service-agreement/orders/$orderId'
      fullPath: '/service-agreement/orders/$orderId'
      preLoaderRoute: typeof AppServiceAgreementOrdersOrderIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/service-agreement/orders/calculate': {
      id: '/_app/service-agreement/orders/calculate'
      path: '/service-agreement/orders/calculate'
      fullPath: '/service-agreement/orders/calculate'
      preLoaderRoute: typeof AppServiceAgreementOrdersCalculateRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAddonsRoute: typeof AppAddonsRoute
  AppCustomerPortalEditorRoute: typeof AppCustomerPortalEditorRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppLeadsRoute: typeof AppLeadsRoute
  AppProfileRoute: typeof AppProfileRoute
  AppTyreConfigRoute: typeof AppTyreConfigRoute
  AppTyreSpecsRoute: typeof AppTyreSpecsRoute
  AppUnauthorizedRoute: typeof AppUnauthorizedRoute
  AppUnavailableRoute: typeof AppUnavailableRoute
  AppVehicleServiceOffersRoute: typeof AppVehicleServiceOffersRoute
  AppVehicleSpecsRoute: typeof AppVehicleSpecsRoute
  AppCustomersTyresRoute: typeof AppCustomersTyresRoute
  AppEmailTemplatesBuilderRoute: typeof AppEmailTemplatesBuilderRoute
  AppOrdersTyresRoute: typeof AppOrdersTyresRoute
  AppOverviewSectionIdRoute: typeof AppOverviewSectionIdRoute
  AppPdfTemplatesBuilderRoute: typeof AppPdfTemplatesBuilderRoute
  AppServiceAgreementAddonsRoute: typeof AppServiceAgreementAddonsRoute
  AppServiceAgreementComplianceRoute: typeof AppServiceAgreementComplianceRoute
  AppServiceAgreementCustomersRoute: typeof AppServiceAgreementCustomersRoute
  AppServiceAgreementSettingsRoute: typeof AppServiceAgreementSettingsRoute
  AppServiceAgreementOrdersOrderIdRoute: typeof AppServiceAgreementOrdersOrderIdRoute
  AppServiceAgreementOrdersCalculateRoute: typeof AppServiceAgreementOrdersCalculateRoute
  AppServiceAgreementOrdersIndexRoute: typeof AppServiceAgreementOrdersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAddonsRoute: AppAddonsRoute,
  AppCustomerPortalEditorRoute: AppCustomerPortalEditorRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppLeadsRoute: AppLeadsRoute,
  AppProfileRoute: AppProfileRoute,
  AppTyreConfigRoute: AppTyreConfigRoute,
  AppTyreSpecsRoute: AppTyreSpecsRoute,
  AppUnauthorizedRoute: AppUnauthorizedRoute,
  AppUnavailableRoute: AppUnavailableRoute,
  AppVehicleServiceOffersRoute: AppVehicleServiceOffersRoute,
  AppVehicleSpecsRoute: AppVehicleSpecsRoute,
  AppCustomersTyresRoute: AppCustomersTyresRoute,
  AppEmailTemplatesBuilderRoute: AppEmailTemplatesBuilderRoute,
  AppOrdersTyresRoute: AppOrdersTyresRoute,
  AppOverviewSectionIdRoute: AppOverviewSectionIdRoute,
  AppPdfTemplatesBuilderRoute: AppPdfTemplatesBuilderRoute,
  AppServiceAgreementAddonsRoute: AppServiceAgreementAddonsRoute,
  AppServiceAgreementComplianceRoute: AppServiceAgreementComplianceRoute,
  AppServiceAgreementCustomersRoute: AppServiceAgreementCustomersRoute,
  AppServiceAgreementSettingsRoute: AppServiceAgreementSettingsRoute,
  AppServiceAgreementOrdersOrderIdRoute: AppServiceAgreementOrdersOrderIdRoute,
  AppServiceAgreementOrdersCalculateRoute:
    AppServiceAgreementOrdersCalculateRoute,
  AppServiceAgreementOrdersIndexRoute: AppServiceAgreementOrdersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordTokenRoute: ResetPasswordTokenRoute,
  ResetPasswordIndexRoute: ResetPasswordIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
